import { useCallback, useEffect, useState } from "react";

export const usePasswordValidation = ({ passwordValue }) => {
  const [passedValidations, setPassedValidations] = useState(0);

  const checkValidations = useCallback((password) => {
    let count = 0;
    if (password?.length >= 8) count++;
    if (/[A-Z]/.test(password)) count++;
    if (/[0-9]/.test(password)) count++;
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) count++;
    setPassedValidations(count);
  }, []);

  useEffect(() => {
    checkValidations(passwordValue);
  }, [passwordValue, checkValidations]);

  return {
    passedValidations
  };
};
